import { ClassActivityPluralTypes } from './types';

const urls = {
  getUnpublishedActivities: (classId: MongoId, activityType: ClassActivityPluralTypes) =>
    `/ppt-plugin/courses/classes/activities?classId=${classId}&type=${activityType}`,
  getPreviouslyUsedActivities: (activityType: ClassActivityPluralTypes) =>
    `/ppt-plugin/activities/used/${activityType}`,
  copyActivity: '/archives/copy/activity',
} as const;

export default urls;
